import { useEffect, useState } from "react";
import { api, mediaUrl } from "../../lib/api";

// Renders only when an active ad is programmed for the slot; otherwise nothing (no gap).
export const AdSlot = ({ slot, className = "" }) => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/ads/${slot}`).then((r) => alive && setAd(r.data)).catch(() => {});
    return () => {
      alive = false;
    };
  }, [slot]);

  if (!ad?.active || !ad.image_url) return null;

  const img = <img src={mediaUrl(ad.image_url)} alt={ad.title || "Publicité"} className="w-full h-auto rounded-md" />;
  return (
    <div className={className} data-testid={`ad-slot-${slot}`}>
      <div className="text-[9px] uppercase tracking-[0.3em] text-neutral-400 mb-1">Publicité</div>
      {ad.link_url ? (
        <a href={ad.link_url} target="_blank" rel="sponsored noopener noreferrer">{img}</a>
      ) : (
        img
      )}
    </div>
  );
};
